import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import { HeroImage } from "../shared/hero-image";
import Icon from "../../../../atoms/icon";
import VuukleCommentCount from "../shared/vuukle/count";
import { StoryElement } from "@quintype/components";
import { produce } from "immer";
import { DfpAd } from "../../../../atoms/dfp-ad";
import { isPremium } from "../../../../../../isomorphic/data/story";
import Cookies from "universal-cookie";
import { triggerwruEvent } from "../../../../../api";
import { GA } from "../../../../../integrations";

import styles from "../text-story-page/styles.m.css";
import stylesVideo from "./styles.m.css";
const cookies = new Cookies();

class VideoStory extends Component {
  constructor(props) {
    super(props);
    const renderReadMore = get(props, ["READMORE_ENABLE"]);
    this.state = {
      isOpened: !renderReadMore || false,
      story: {}
    };
    this.outerarticle = React.createRef();
  }

  toggleBox = (Id, commentTrigger = false) => {
    const parentStory = cookies.get("story-view");
    window.scrollTo({
      top: this.outerarticle.current.offsetTop - 120
    });
    this.setState(oldState => ({ isOpened: !oldState.isOpened }));
    if (!this.state.isOpened) {
      global.app.maybeSetUrl(
        "/" + this.props.story.slug + "?artfrm=" + this.props.versionStat,
        get(this.props, ["story", "seo", "meta-title"], this.props.story.headline)
      );
      GA.customEvent(`feed_click_${this.props.versionStat}`, `${this.props.index}`, parentStory.headline);
      this.props.fireVirtualPageView();
      triggerwruEvent(this.props.story.id, cookies.get("thinmint"), "STORY_VIEW_EVENT");
      if (this.props.versionStat === "v3")
        triggerwruEvent(this.props.story.id, cookies.get("thinmint"), "RECOMMENDATION_VIEW_EVENT");
    }
    this.props.checkInfoStatus({ id: Id, status: !this.state.isOpened });
  };

  commentTriggerEvent = () => {
    const ID = get(this.props, ["story", "id"], () => null);
    this.toggleBox(ID, true);
  };

  render() {
    const { isOpened } = this.state;
    const renderSocialMedia = get(this.props, ["renderSocialMedia"], () => null);
    const renderHeaderCard = get(this.props, ["renderHeaderCard"], () => null);
    const renderFooter = get(this.props, ["renderFooter"], () => null);
    const renderfloatingBar = get(this.props, ["renderfloatingBar"], () => null);
    const getStorycardLength = get(this.props, ["story", "cards"], () => null).length;
    const renderSocialMediaForMobile = get(this.props, ["renderSocialMediaForMobile"], () => null);
    const renderPremiumCard = get(this.props, ["renderPremiumCard"], () => null);
    const renderSecondaryCard = get(this.props, ["renderSecondaryCard"], () => null);
    const renderReadMore = get(this.props, ["READMORE_ENABLE"]);
    const storyHeadline = get(this.props, ["story", "subheadline"], () => null);
    const StoryId = get(this.props, ["story", "id"], () => null);

    const cards = get(this.props, ["story", "cards"], []);

    let firstVideoElement;
    let firstVideoCard = {};

    for (let cardIterator = 0; cardIterator < cards.length; cardIterator++) {
      const foundVideo = cards[cardIterator]["story-elements"].find(
        ({ type, subtype }) => type === "youtube-video" || (type === "jsembed" && subtype === "dailymotion-video")
      );
      if (foundVideo) {
        firstVideoElement = foundVideo;
        firstVideoCard = cards[cardIterator];
        break;
      }
    }

    const renderHeaderVideo = () => {
      if (!firstVideoElement) {
        return null;
      }

      return (
        <div className={stylesVideo["header-video"]}>
          <StoryElement
            element={firstVideoElement}
            card={firstVideoCard}
            key={firstVideoElement.id}
            story={this.props.story}
          />
        </div>
      );
    };

    return (
      <div className={styles["main-content"]} ref={this.outerarticle}>
        <article
          className={`infinity-template ${renderReadMore ? styles["nextstory-sec"] : styles["mainstory-sec"]} ${
            styles["story-body"]
          } js-story`}
        >
          {!isOpened ? (
            <div onClick={() => !this.state.isOpened && this.toggleBox(StoryId)} style={{ cursor: "pointer" }}>
              {renderHeaderCard({ readMore: isOpened })}
              {renderSecondaryCard()}
              <HeroImage
                story={this.props.story}
                className={`${!isOpened ? "closed" : ""} ${renderReadMore ? "remove-margin" : ""}`}
              />
              <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
            </div>
          ) : (
            <div>
              {renderHeaderVideo()}
              {renderHeaderCard({ readMore: isOpened })}
            </div>
          )}
          {renderPremiumCard()}
          {isOpened && (
            <div className="content-section">
              {this.props.story.cards.map((card, index) => {
                const newCard = produce(card, draft => {
                  draft["story-elements"] = draft["story-elements"].filter(
                    element => element.id !== firstVideoElement.id
                  );
                });
                return (
                  <React.Fragment key={newCard.id}>
                    {index === 3 &&
                      !isPremium(this.props.story) && (
                        <DfpAd story={this.props.story} adtype="Inarticle_fork" placement="story" />
                      )}
                    <StoryCard card={newCard} story={this.props.story} />
                    {index !== getStorycardLength - 1
                      ? !isPremium(this.props.story) && (
                          <DfpAd story={this.props.story} adtype="Rectangle" placement="story" />
                        )
                      : ""}
                  </React.Fragment>
                );
              })}
              {renderFooter()}
            </div>
          )}
          {!renderReadMore ? (
            isOpened === false ? (
              <div className="story-bottom main-story readmore">
                <div className={`${styles["comments"]} show-desktop`}>
                  {renderSocialMedia("show-desktop")}
                  <a className={`${styles["comments_link"]}`} onClick={() => this.toggleBox(StoryId, true)}>
                    <Icon className="svg-comments" type="newsletter" />
                    <VuukleCommentCount className="vu-comments" storyId={StoryId} />
                  </a>
                </div>
                {renderSocialMediaForMobile({ commentTriggerEvent: this.commentTriggerEvent })}
                <a onClick={() => this.toggleBox(StoryId)} className="expandView">
                  வீடியோவைப் பார்க்க <Icon type="arrow" />
                </a>
              </div>
            ) : (
              <a onClick={() => this.toggleBox(StoryId)} className="expandView expand-close">
                பின் செல்ல
              </a>
            )
          ) : isOpened === false ? (
            <div className="loadmore-stories">
              <div className="story-bottom next-stories readmore">
                <div className={`${styles["comments"]} show-desktop`}>
                  {renderSocialMedia("show-desktop")}
                  <a className={`${styles["comments_link"]}`} onClick={() => this.toggleBox(StoryId, true)}>
                    <Icon className="svg-comments" type="newsletter" />
                    <VuukleCommentCount className="vu-comments" storyId={StoryId} />
                  </a>
                </div>
                {renderSocialMediaForMobile({ commentTriggerEvent: this.commentTriggerEvent })}
                <a onClick={() => this.toggleBox(StoryId)} className="expandView">
                  வீடியோவைப் பார்க்க <Icon type="arrow" />
                </a>
              </div>
            </div>
          ) : (
            <a onClick={() => this.toggleBox(StoryId)} className="expandView expand-close">
              பின் செல்ல
            </a>
          )}
        </article>
        {isOpened && renderSocialMedia("show-desktop")}
        {isOpened && renderfloatingBar()}
      </div>
    );
  }
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
VideoStory.propTypes = {
  story: story,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  fireVirtualPageView: PropTypes.func,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  renderSecondaryCard: PropTypes.func,
  index: PropTypes.number
};

export { VideoStory };
